import { render, staticRenderFns } from "./TransmissionContent.vue?vue&type=template&id=1bc86ce1&"
import script from "./TransmissionContent.vue?vue&type=script&lang=ts&"
export * from "./TransmissionContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports